module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"docs":"Dokumenty","forum":"Fórum","version":"Verze"},"de":{"docs":"Dokumentation","forum":"Forum","version":"Version"},"es":{"docs":"Documentos","forum":"Foro","version":"Versión"},"fr":{"docs":"Documentation","forum":"Forum","version":"Version"},"id":{"docs":"Dokumen","forum":"Forum","version":"Versi"},"ja":{"docs":"Docs","forum":"フォーラム","version":"バージョン"}}')
  delete Component.options._Ctor
}
